import { LOG_ADD } from 'cityads-v3/actions/log';

const initialState = {
  log: []
};

export default function language(state = initialState, action = {}) {
  switch (action.type) {
    case LOG_ADD:
      return {
        ...state,
        log: [
          ...state.log,
          action.log
        ]
      };

    default:
      return state;
  }
}
